<ng-container *ngIf="relatedServices.length">
  <app-divider></app-divider>
  <app-divider></app-divider>

  <div class="section container">
    <h3 class="section-title">Serviços Relacionados</h3>

    <div [class.section-content]="isDesktop">
      <ng-container *ngFor="let item of relatedServices">
        <div class="related-service">
          <app-small-card-link
            [text]="item.nome"
            [colorStyle]="'inverted'"
            [iconName]="item.icone || 'layout-grid'"
            (clickEvent)="handleRelatedServiceLinkClick(item.url)"
          ></app-small-card-link>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
